import Identifiable from 'interfaces/Identifiable';


export enum ArticleType {
  Listicle = 'Listicle',
  Personal_Story = 'Personal_Story',
  Roundup = 'Roundup',
  Review = 'Review',
  Case_Study = 'Case_Study',
  Announcement = 'Announcement',
  Customer_Spotlight = 'Customer_Spotlight',
  How_To = 'How_To',
  Thought_Leadership = 'Thought_Leadership',
  Checklist = 'Checklist',
  Cheat_Sheet = 'Cheat_Sheet',
  Template = 'Template',
}

export interface Document extends Identifiable {
  id: number;
  statusId: number;
  content: string;
  imageUrl?: string;
  keywordId?: number;
  siteSectionId?: number;
  articleType?: ArticleType;
  shortDescription?: string;
  fbMessageTmp?: string;
  twMessageTmp?: string;
  liMessageTmp?: string;
  title?: string;
  plannedDate?: Date;
  actualDate?: Date;
  projectId: number;
  targetLength: number;
  cmsPageId?: number;
  themeId?: number;
}
